import React, { useState } from 'react';
import { HelpOnboarding } from 'src/assets/icons';
import { HelpImage } from 'src/assets/images';
import { contacts } from 'src/common';
import './help-button.scss';

interface HelpButtonConfig {
  className?: string;
  onOpen?: () => void;
  onPhoneNumberClicked?: () => void;
  onEmailClicked?: () => void;
}

export const HelpButton = ({
  className,
  onOpen,
  onPhoneNumberClicked,
  onEmailClicked,
}: HelpButtonConfig) => {
  const [showHelp, setShowHelp] = useState(false);
  const helpPhoneUrl = contacts.numberUrl;
  const helpEmail = contacts.email;
  const helpEmailUrl = contacts.emailUrl;

  return (
    <div className={`${className || ''} HelpButton`} data-testid="HelpFloatingActionButton">
      {showHelp && (
        <div className="container has-padding-x-2 has-mobile-padding-x-0">
          <div automationid="Help_Div_HelpOpen" className="help-image has-mobile-padding-top-0">
            <img src={HelpImage} alt="help" />
          </div>
          <div className="help-text">Need help? Get in touch with us:</div>
          <div className="link-container has-padding-x-7 has-padding-top-6 has-padding-bottom-0">
            <div>
              <a
                className="help-link help-subtext"
                href={helpPhoneUrl}
                onClick={onPhoneNumberClicked}
              >
                {contacts.number}
              </a>
            </div>
            <div>
              <a
                className="help-link help-subtext break-text"
                href={helpEmailUrl}
                onClick={onEmailClicked}
              >
                {helpEmail}
              </a>
            </div>
          </div>
        </div>
      )}
      <div
        className="is-pulled-right has-margin-top-3 has-mobile-margin-top-6"
        automationid="Help_Button_HelpOpen"
        onClick={() => {
          setShowHelp(!showHelp);
          if (!showHelp) {
            onOpen && onOpen();
          }
        }}
      >
        <HelpOnboarding className="is-clickable" open={showHelp} />
      </div>
    </div>
  );
};
